export const devlog = (...strs) => {
  if (process.env.NODE_ENV === 'development') {
    console.log('***** development log *****');
    for (let index in strs) {
      console.log(strs[index]);
    }
  }
};
